function Eagerly_Tools_Cookie(options) {
	this.options = $.extend({
		debug: false,
		//root: '/includes/cookie',
		before: function (stat) { }, //stat = open, close of submit
		after: function (stat) { } //stat = open, close of submit
	}, options);

	this.first_loaded = false;
	this.youtube_loaded = false;
	this.fb_loaded = false;
	this.twitter_loaded = false;
	this.google_loaded = false;
	if (cookieData.initial_settings) {
		this.initial_settings = cookieData.initial_settings;
	}
	var _this = this;

	this.form = {
		checkbox: function () {
			$('.cookie-checkbox-group input').change(function () {
				var $this = $(this).parents('.cookie-checkbox-group');
				if ($(this).is(':checked')) {
					$this.addClass('checked');
				} else {
					$this.removeClass('checked');
				}
			});
		},
		init: function () {
			this.checkbox();
		},
	};

	this.cookie = {
		$container: false,
		$overlay: false,
		$btn: false,
		active: false,
		settings: false,
		initIntro: true,
		open: function () {
			if (_this.cookie.active == false) {
				$.isFunction(options.before) && options.before.call(_this.cookie.$container, 'open');
				this.active = true;
				this.$overlay.show();
				if (this.initIntro == true && _this.cookie.$containerIntro.length >= 1) {
					_this.cookie.$containerIntro.removeClass('hide-mob');
				} else {
					_this.cookie.$container.removeClass('hide-mob');
					// set max height scroller:
					var h = $(window).height() - $('.cookie-fb-top').outerHeight(true) - $('.cookie-fb-bottom').outerHeight(true);
					$('.cookie-fb-scroller').css({ 'max-height': h });
				}
				$('body').init('.cookie-svg-icon', $('.cookie-fb-content'));
				if (this.initIntro == true && _this.cookie.$containerIntro.length >= 1) {
					setTimeout(function () {
						_this.cookie.$containerIntro.addClass('active');
					}, 100);
				} else {
					setTimeout(function () {
						_this.cookie.$container.addClass('active');
					}, 100);
				}
				setTimeout(function () {
					if ('undefined' != typeof $.fn.icons) {
						$('body').icons.init('.svg-icon');
					}
					_this.cookie.$overlay.addClass('active');
				}, 100);
				this.initIntro = false;

				// trapfocus:
				// console.log('trapfocus')
				// console.log(window.focusTrap)
				const container = document.getElementById('eagerly-tools-cookie');

				const focusTrap = window.focusTrap.createFocusTrap('#eagerly-tools-cookie', {
					onActivate: () => container.classList.add('is-active'),
					onDeactivate: () => container.classList.remove('is-active'),
				});

				// first time:
				document.getElementById('privacy').focus();
				activateTrap();

				function activateTrap() {
					//console.log("activateTrap");
					focusTrap.activate();
				}

				function deactivateTrap() {
					//console.log('deactivate')
					focusTrap.deactivate();
				}

				document
					.querySelector('.js-cookie-btn')
					.addEventListener('click', activateTrap);
				document
					.querySelector('.js-close-cookie')
					.addEventListener('click', deactivateTrap);
			}

			$('.js-cookie-fb-title').on('focus', function () {
				// "last" focus guard got focus: set focus to the first field
				$('#privacy').focus();
			});
		},
		close: function (switchPopup) {
			if (_this.cookie.active == true) {
				$.isFunction(options.before) && options.before.call(_this.cookie.$container, 'close');
				_this.cookie.active = false;
				setTimeout(function () {
					if (switchPopup == false) {
						_this.cookie.$overlay.removeClass('active');
					}
					if (_this.cookie.$containerIntro.hasClass('active')) {
						_this.cookie.$containerIntro.removeClass('active');
					} else {
						_this.cookie.$container.removeClass('active');
					}
					setTimeout(function () {
						if (switchPopup == false) {
							_this.cookie.$overlay.hide();
							_this.cookie.$container.addClass('hide-mob');
						}
						$.isFunction(options.after) && options.after.call(_this.cookie.$container, 'close');
					}, 250);
				}, 10);
			}
			if (switchPopup == false) {
				_this.cookie.save();
			}
		},
		openSub: function ($this) {
			if (_this.cookie.active == true) {
				var h = $this.next('.cookie-item-content').height();
				var $item = $this.parents('.cookie-checkbox-group');
				if ($item.hasClass('active')) {
					$item.removeClass('active').css({ 'height': 60 });
				} else {
					$item.addClass('active').css({ 'height': 60 + h }).siblings('.cookie-checkbox-group').removeClass('active').css({ 'height': 60 });
				}
			}
		},
		addSettingsClasses: function () {
			//adds classes to checkboxes depending on cookie settings
			$('.cookie-checkbox-group input').each(function () {
				if (_this.cookie.settings && _this.cookie.settings.indexOf($(this).val()) > -1) {
					$(this).attr('checked', true);
					$(this).closest('.cookie-field').addClass('checked');
				}
			});
		},
		clicks: function () {
			this.setHTMLElements();
			_this.cookie.$replacementBtn.unbind('click').on('click', function (e) {
				e.preventDefault();
				if (_this.cookie.active == false) {
					_this.cookie.open();
				} else {
					_this.cookie.close(false);
				}
			});
			_this.cookie.$btn.unbind('click').on('click', function (e) {
				e.preventDefault();
				if (_this.cookie.active == false) {
					_this.cookie.open();
				}
			});
			_this.cookie.$container.find('.btn-close,.btn-ok').unbind('click').on('click', function (e) {
				e.preventDefault();
				if (_this.cookie.active == true) {
					_this.cookie.close(false);
				}
			});
			_this.cookie.$containerIntro.find('.btn-close,.btn-ok-big').unbind('click').on('click', function (e) {
				e.preventDefault();
				if (_this.cookie.active == true) {
					_this.cookie.close(false);
				}
			});
			_this.cookie.$containerIntro.find('.btn-change').unbind('click').on('click', function (e) {
				e.preventDefault();
				if (_this.cookie.active == true) {
					_this.cookie.close(true);
					_this.cookie.open();
				}
			});
			_this.cookie.$overlay.unbind('click').on('click', function (e) {
				_this.cookie.close(false);
			});
			$('.open-cookie-item').unbind('click').on('click', function (e) {
				e.preventDefault();
				_this.cookie.openSub($(this));
			});
			$('.cookie-fb-bottom .cookie-checkbox-group input').unbind('change').change(function () {
				if ($(this).is(':checked')) {
					$('.cookie-fb-scroller .cookie-checkbox-group:not(.disabled)').each(function () {
						$(this).addClass('checked').find('input').prop('checked', true);
						setTimeout(function () {
							_this.cookie.close(false);
						}, 250);
					});
				} else {
					$('.cookie-fb-scroller .cookie-checkbox-group:not(.disabled)').each(function () {
						$(this).removeClass('checked').find('input').prop('checked', false);
					});
				}
			});
			$('.cookie-fb-scroller .cookie-checkbox-group input').unbind('change').change(function () {
				var active = true;
				$('.cookie-fb-scroller .cookie-checkbox-group input').each(function () {
					if (!$(this).is(':checked') && !$(this).is(':disabled')) {
						active = false;
					}
				});
				if (active === true) {
					$('.cookie-fb-bottom .cookie-checkbox-group input').prop('checked', true);
					$('.cookie-fb-bottom .cookie-checkbox-group').addClass('checked');
				} else {
					$('.cookie-fb-bottom .cookie-checkbox-group input').prop('checked', false);
					$('.cookie-fb-bottom .cookie-checkbox-group').removeClass('checked');
				}
			});
			$('.cookie-fb-scroller .cookie-checkbox-group input').trigger('change');
		},
		init: function () {
			this.setHTMLElements();

			_this.cookie.settings = this.get('cookie_settings');
			_this.cookie.addSettingsClasses();
			_this.cookie.updateDOM('');
			_this.cookie.doGTMEvents('');

			_this.cookie.clicks();
			if (_this.first_loaded == true) {
				this.initIntro = true;
				_this.first_loaded = false;
				var h_top = _this.cookie.$container.find('.cookie-fb-top').outerHeight(true),
					h_option = _this.cookie.$container.find('.cookie-fb-scroller').children('.cookie-field').outerHeight(true);
				//console.log( h_top, h_option );
				var h = _this.cookie.$container.find('.cookie-fb-content').outerHeight(true) - h_top - h_option;
				_this.cookie.$container.addClass('first');
				_this.cookie.$btn.click();
			} else {
				this.initIntro = false;
				_this.cookie.$container.removeClass('first').removeAttr('style');
			}
		},
		save: function () {
			var new_settings = [],
				prev_settings = _this.cookie.settings;
			_this.cookie.$container.find('.cookie-fb-scroller input:checked').each(function () {
				new_settings.push($(this).val());
			});
			_this.cookie.set('cookie_settings', new_settings, true);
			_this.cookie.settings = new_settings.join(',');
			// todo: update front-end
			_this.cookie.updateDOM(prev_settings);
			_this.cookie.doGTMEvents(prev_settings);
		},
		get: function (name) {
			var value = "; " + document.cookie;
			var parts = value.split("; " + name + "=");
			if (parts.length == 2) {
				return parts.pop().split(";").shift();
			}
			return false;
		},
		set: function (name, value, time) {
			var expires = "";
			if (time != 'session' && time != false) {
				var date = new Date();
				date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
				expires = "; expires=" + date.toGMTString();
			}
			document.cookie = name + '=' + value + expires + '; SameSite=Strict; path=/'
		},
		updateDOM: function (prev_settings) {

			if (false !== _this.cookie.settings) {
				var settings = _this.cookie.settings;

				if ('' != prev_settings && prev_settings == settings) {
					_this.debug('no change!');

					return false;
				}

				if (settings.indexOf(',') > -1) {
					settings = settings.split(',');
				} else {
					settings = [settings];
				}

				if ('' != prev_settings) {
					if (prev_settings.indexOf(',') > -1) {
						prev_settings = prev_settings.split(',');
					} else {
						prev_settings = [prev_settings];
					}
				} else {
					prev_settings = settings;
				}

				if (settings.length < prev_settings.length || (settings.length > prev_settings.length && 1 == cookieData.forceReload)) {
					// NOTE: reload page to unload API's
					if (_this.first_loaded == false) {
						window.location.reload();
					}
				} else if (settings.length == 1) {
					_this.debug(settings);

					_this.disableYouTube();
					_this.enableEmbeds(['functional']);
				} else {
					// NOTE: load specific API's
					for (var key in settings) {
						_this.debug(settings[key]);

						switch (settings[key]) {
							case 'tracking':
								_this.enableYouTube();
								_this.enableShare();
								_this.enableEmbeds(['tracking']);
								_this.enableScript();
								_this.enableDataDiv();
								_this.enableFacebook();
								_this.enableTwitter();
								_this.enableLinkedin();
								break;
							case 'settings':
							case 'statistics':
								_this.enableStatistics();
							case 'other':
								// not yet
								break;
						}
					}
				}
			}
		},
		doGTMEvents: function (prev_settings) {
			if (false !== _this.cookie.settings) {
				var settings = _this.cookie.settings;

				if ('' != prev_settings && prev_settings == settings) {
					_this.debug('GTM: no change!');
					return false;
				}

				settings = _this.settingsStringToArray(settings);

				window.dataLayer = window.dataLayer || [];

				var doDefaultOnlyEvent = true;

				for (var key in settings) {
					if (settings[key] != 'default') {
						doDefaultOnlyEvent = false;
					}
					_this.debug('GTM push event: "eagerly_cookie_' + settings[key] + '"');
					window.dataLayer.push({
						'event': 'eagerly_cookie_' + settings[key]
					});
				}

				if (doDefaultOnlyEvent) {
					window.dataLayer.push({
						'event': 'eagerly_cookie_onlydefault'
					});
				}
			}
		},
		setHTMLElements: function () {
			this.$container = $('#eagerly-tools-cookie');
			this.$containerIntro = $('#eagerly-tools-cookie-intro');
			this.$overlay = $('#eagerly-tools-cookie-overlay');
			this.$btn = $('.js-cookie-btn');
			this.$replacementBtn = $('.js-cookie-replacement-btn');
		},
	};

	this.debug = function (message) {
		if (this.options.debug) {
			//console.log( message );
		}
		return;
	};

	this.settingsStringToArray = function (string) {
		if (string.indexOf(',') > -1) {
			array = string.split(',');
		} else {
			array = [string];
		}
		return array;
	};

	this.init();
}

Eagerly_Tools_Cookie.prototype.close = function () {
	this.cookie.open();
}


Eagerly_Tools_Cookie.prototype.open = function () {
	this.cookie.close(false);

}

function urldecode(url) {
	return decodeURIComponent(url.replace(/\+/g, ' '));
}

Eagerly_Tools_Cookie.prototype.enableYouTube = function () {
	//this enables youtube in the theme, not as embeds
	var _this = this;
	_this.debug('enable YT');
	var check_yt;
	check_yt = setInterval(function () {
		if ('undefined' != typeof YTplayer) {
			clearInterval(check_yt);
			_this.youtube_loaded = true;
			_this.debug('init YT');

			YTplayer.init = false;
			$.fn.youtube();
		}
	}, 100);

	//initiates youtube theme js NOT YOUTUBE EMBEDS
	//(in bijv. Podium sites, activate these and remove them from theme)
	//$('body').youtube.initBalk();
	//$('body').youtube.initHero($('#hero-player'));
}

Eagerly_Tools_Cookie.prototype.enableEmbeds = function (exceptions) {

	if ('undefined' == typeof exceptions) {
		var exceptions = [];
	}

	// replace element .eagerly-tools-cookie-blocked with the value inside its data-embed
	if (exceptions.indexOf('tracking') > -1) {
		if ($('.eagerly-tools-cookie-blocked').length > 0) {
			$('.eagerly-tools-cookie-blocked').each(function () {
				var embed = $(this).data('embed');
				if (typeof embed !== 'undefined') {
					$(this).replaceWith(urldecode(embed));
				}
			});
		}
	}
	//show embed warning for embeds that are still blocked
	$('.eagerly-tools-cookie-blocked').removeClass('hide');
}

Eagerly_Tools_Cookie.prototype.enableStatistics = function () {

}

Eagerly_Tools_Cookie.prototype.disableYouTube = function () {

}

Eagerly_Tools_Cookie.prototype.enableScript = function () {

}
Eagerly_Tools_Cookie.prototype.enableFacebook = function () {

}
Eagerly_Tools_Cookie.prototype.enableTwitter = function () {

}
Eagerly_Tools_Cookie.prototype.enableLinkedin = function () {

}

Eagerly_Tools_Cookie.prototype.enableDataDiv = function () {
	$('.cookie-data-div').each(function () {
		var data = $(this).data('div');
		if (typeof data !== 'undefined') {
			$(this).replaceWith(urldecode(data));
			$(this).removeClass('hide');
		}
	});
}

Eagerly_Tools_Cookie.prototype.changeEmbedWarning = function () {

	//changes embed warning if iframe contains the string

	var embedNames = ['maps', 'youtu', 'vimeo', 'dailym', '9292', 'soundcl', 'pippa', 'spotify', 'mixcloud', 'instagram', 'soundsgood', 'twit', 'mailchimp', 'Mailchimp', 'MailChimp', 'facebook', 'soundcloud', 'bandcamp'];
	var embedNicenames = ['Google Maps', 'YouTube', 'Vimeo', 'Dailymotion', '9292', 'SoundCloud', 'Pippa', 'Spotify', 'MixCloud', 'Instagram', 'Soundsgood', 'Twitter', 'Mailchimp', 'Mailchimp', 'Mailchimp', 'Facebook', 'SoundCloud', 'Bandcamp'];
	if (embedNames.length > 0) {
		$('.eagerly-tools-cookie-blocked').each(function () {
			for (var i = 0; i < embedNames.length; i++) {
				embedName = embedNames[i];
				embedNicename = embedNicenames[i];
				var regexName = RegExp(embedName);
				if (regexName.test($(this).data('embed'))) {
					if (Eagerly_Tools_Cookie.prototype.get_current_language() === 'en') {
						$(this).children('span').html('Your cookie settings are blocking ' + embedNicename + '.<br />Please adjust <a href="#" class="">your preferences</a> to enable ' + embedNicename + '.');
					} else {
						$(this).children('span').html('Je cookie instellingen blokkeren ' + embedNicename + '.<br />Pas <a href="#" class="">je instellingen</a> aan om gebruik te maken van ' + embedNicename + '.');
					}
				}
			}
		});
	}
}

Eagerly_Tools_Cookie.prototype.enableShare = function () {

}

Eagerly_Tools_Cookie.prototype.get_current_language = function () {
	var lang = $('html').attr('lang');
	if (lang.indexOf('en') > -1) {
		return 'en';
	}
	return 'nl';
}

Eagerly_Tools_Cookie.prototype.init = function () {
	var _this = this;
	if (_this.cookie.get('cookie_settings') === false) {
		_this.first_loaded = true;
		_this.cookie.set('cookie_settings', _this.initial_settings.join(','), true);
		_this.cookie.settings = _this.initial_settings.join(',')
	}
	_this.changeEmbedWarning();
	_this.cookie.init();
	_this.form.init();

	setTimeout(function () {
		$('#eagerly-tools-cookie-btn').css({ 'opacity': 1 });
	}, 250);

}

$(function () {

	eagerly_cookie = new Eagerly_Tools_Cookie({
		debug: false,
		//root : '/includes/cookie',
		before: function (stat) {
			//console.log(stat);
			// voor bijvoorbeeld lock scroll
			// eagerly_cookie.cookie.clicks();
		},
		after: function (stat) {
			//console.log(stat);
			// voor bijvoorbeeld unlock scroll
		}
	});
});
